"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var images_1 = require("../mock/images");
var customerTemplateUrl = "".concat(process.env.CB_EMAIL_TEMPLATE_SERVICE_URL);
var TemplateImages = {
    getImagesList: function (token) {
        return rest_1.default.get({
            mockFunc: images_1.getImagesList,
            url: "".concat(customerTemplateUrl, "/images-urls"),
            token: token,
        });
    },
    getLogoUrl: function (token) {
        return rest_1.default.get({
            mockFunc: images_1.getLogoUrl,
            url: "".concat(customerTemplateUrl, "/logo-url"),
            token: token,
        });
    },
    getUploadImageUrl: function (token, fileType) {
        return rest_1.default.post({
            mockFunc: images_1.getUploadImageUrl,
            url: "".concat(customerTemplateUrl, "/upload-image"),
            token: token,
            body: { fileType: fileType },
        });
    },
    uploadImage: function (signedUrl, image, type) {
        return fetch(signedUrl, {
            method: 'PUT',
            body: new Blob([image], { type: type }),
        });
    },
};
exports.default = TemplateImages;
